export default __webpack_public_path__ + "static/media/injured_animals.623880eb.svg";